import { faGear } from "@fortawesome/free-solid-svg-icons/faGear";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog, DialogContent, DialogTitle, Icon } from '@mui/material'
import { IColuna } from 'app/types/IColuna'
import clsx from 'clsx'
import React, { useState } from 'react'
import { PaperArrastavel } from '../../dialog-arrastavel/PaperArrastavel'

const estilosGridCliente = require('./grid-clientes.module.scss').default


export type AcoesHeadProps = {
    onAlterarFonte?: (tamanho: number) => void
    colunas: IColuna[],
    onToggleColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void
    onToggleSelecionarTodasColunas: (selecionar: boolean) => void
    tamanhoFonte: number
    exibirIconesAumentarDiminuirFonte?: boolean
    larguraLinha?: number
    nomeGrid?: "PESQUISAR_CLIENTE_ORCAMENTO"
    permiteEngrenagemGrid: boolean
}

export const AcoesHead = (props: AcoesHeadProps) => {
    const [mostrarFerramentas, setMostrarFerramentas] = useState<boolean>(false);
    const [icon, setIcon] = useState<string>("arrow_drop_up");
    const [exibirSelecaoColunas, setExibirSelecaoDeColunas] = useState(false)


    const selecaoDeColunas = <div className="_grid _grid-cols-1 _grid-flow-row"
        id="AcoesHead_PesquisaCLiente_SelecaoColunas"
    >

        <div className="_flex _flex-row _justify-start _max-w-xs _items-end">
            <div className="_mr-4">
                <input
                    type="checkbox"
                    checked={props.colunas.every(c => c.Selecionada == true)}
                    onChange={e => props.onToggleSelecionarTodasColunas(e.target.checked)} />
            </div>

            <b>Todas</b>

        </div>

        {props.colunas.map(coluna => <div
            className="_flex _flex-row _justify-start _max-w-xs _items-end"
            key={coluna.Nome}>

            <div className="_mr-4">
                <input
                    type="checkbox"
                    checked={coluna.Selecionada ?? false}
                    onChange={() => props.onToggleColunaSelecionada(coluna.Nome, !coluna.Selecionada)} />
            </div>

            {coluna.Nome}
        </div>)}
    </div>

    const selecaoDeColunasDialog = <Dialog open={exibirSelecaoColunas} onClose={() => setExibirSelecaoDeColunas(false)} PaperComponent={PaperArrastavel}>
        <DialogTitle>
            Selecionar colunas para exibição
        </DialogTitle>
        <DialogContent>
            {selecaoDeColunas}
        </DialogContent>
    </Dialog>

    const botoes = <div style={{
        width: props.larguraLinha != undefined ? `${props.larguraLinha}px` : undefined

    }} className={clsx(["_flex _flex-row _mt-4 _gap-x-2", estilosGridCliente.acoesHead])}>

        {props.permiteEngrenagemGrid &&
            <FontAwesomeIcon icon={faGear} className="_text-2xl _cursor-pointer" onClick={() => setExibirSelecaoDeColunas(true)} />
        }
 
        {(props.exibirIconesAumentarDiminuirFonte ?? true) && <>
            <button
                id="AcoesHead_PesquisaCLiente_AumentarFonte"
                className={clsx('no-global-button', estilosGridCliente.botaoAumentarDiminuirFonte)}
                onClick={() => props.onAlterarFonte?.(props.tamanhoFonte + 1)}
                disabled={props.tamanhoFonte >= 26}
            >A+
            </button>
            <button
                id="AcoesHead_PesquisaCLiente_DiminuirFonte"
                className={clsx('no-global-button', estilosGridCliente.botaoAumentarDiminuirFonte)}
                onClick={() => props.onAlterarFonte?.(props.tamanhoFonte - 1)}
                disabled={props.tamanhoFonte <= 8}
            >A-
            </button></>}
    </div>

const iconeExibirEsconderOpcoes = (
    <button
        style={{ marginLeft: '14px', height: '20px' }}
        id="AcoesHead_PesquisaCLiente_ExibirFerramentas"
        className="no-global-button"
        onClick={() => {
            setMostrarFerramentas(!mostrarFerramentas);
            setIcon(icon == "arrow_drop_up" ? "arrow_drop_down" : "arrow_drop_up");
        }}
    >
        <Icon>{icon}</Icon>
    </button>
);

    return <>
        <div className={estilosGridCliente.menu}
            id="AcoesHead_PesquisaCLiente_ContainerFerramentas"
        >
            {iconeExibirEsconderOpcoes}
            {mostrarFerramentas && (
                <section id="AcoesHead_PesquisaCLiente_Ferramentas">
                    {botoes}
                </section>
            )}
        </div>

        {exibirSelecaoColunas && selecaoDeColunasDialog}
    </>
}